import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceiptsEnrichedLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 116,
	height: 116,
	viewBox: "0 0 116 116",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M58 109C86.1665 109 109 86.1665 109 58C109 29.8335 86.1665 7 58 7C29.8335 7 7 29.8335 7 58C7 86.1665 29.8335 109 58 109Z",
			fill: "#D8FFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.9297 62.8C93.6197 62.8 90.9297 60.11 90.9297 56.8C90.9297 53.49 93.6197 50.8 96.9297 50.8C100.24 50.8 102.93 53.49 102.93 56.8C102.93 60.11 100.24 62.8 96.9297 62.8ZM96.9297 52.8C94.7197 52.8 92.9297 54.59 92.9297 56.8C92.9297 59.01 94.7197 60.8 96.9297 60.8C99.1397 60.8 100.93 59.01 100.93 56.8C100.93 54.59 99.1397 52.8 96.9297 52.8Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.8799 16.26C86.2606 16.26 87.3799 15.1407 87.3799 13.76C87.3799 12.3793 86.2606 11.26 84.8799 11.26C83.4992 11.26 82.3799 12.3793 82.3799 13.76C82.3799 15.1407 83.4992 16.26 84.8799 16.26Z",
			fill: "#0597A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4805 72.2C21.4135 72.2 22.9805 70.6329 22.9805 68.7C22.9805 66.767 21.4135 65.2 19.4805 65.2C17.5475 65.2 15.9805 66.767 15.9805 68.7C15.9805 70.6329 17.5475 72.2 19.4805 72.2Z",
			fill: "#0597A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1 89.0899L22.04 85.1499C22.63 84.5599 22.63 83.6099 22.04 83.0299C21.45 82.4499 20.5 82.4399 19.92 83.0299L15.98 86.9699L12.04 83.0299C11.45 82.4399 10.5 82.4399 9.92004 83.0299C9.34004 83.6199 9.33004 84.5699 9.92004 85.1499L13.86 89.0899L9.92004 93.0299C9.33004 93.6199 9.33004 94.5699 9.92004 95.1499C10.21 95.4399 10.6 95.5899 10.98 95.5899C11.36 95.5899 11.75 95.4399 12.04 95.1499L15.98 91.2099L19.92 95.1499C20.21 95.4399 20.6 95.5899 20.98 95.5899C21.36 95.5899 21.75 95.4399 22.04 95.1499C22.63 94.5599 22.63 93.6099 22.04 93.0299L18.1 89.0899Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.07 33.1401H100.5V27.5701C100.5 26.7401 99.8297 26.0701 98.9997 26.0701C98.1697 26.0701 97.4997 26.7401 97.4997 27.5701V33.1401H91.9297C91.0997 33.1401 90.4297 33.8101 90.4297 34.6401C90.4297 35.4701 91.0997 36.1401 91.9297 36.1401H97.4997V41.7101C97.4997 42.5401 98.1697 43.2101 98.9997 43.2101C99.8297 43.2101 100.5 42.5401 100.5 41.7101V36.1401H106.07C106.9 36.1401 107.57 35.4701 107.57 34.6401C107.57 33.8101 106.9 33.1401 106.07 33.1401Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M31.1204 92.8301V23.6801C31.1204 23.0701 31.7904 22.7101 32.3004 23.0401L39.6304 27.8501C39.9004 28.0301 40.2503 28.0201 40.5103 27.8201L48.2304 22.0601C48.4904 21.8601 48.8503 21.8601 49.1203 22.0401L57.7603 28.0201C58.0203 28.2001 58.3704 28.2001 58.6304 28.0201L67.1804 22.0501C67.4604 21.8601 67.8303 21.8701 68.0903 22.0801L75.4804 27.9701C75.7404 28.1801 76.1103 28.1901 76.3803 28.0001L83.6904 23.0501C84.2004 22.7101 84.8803 23.0701 84.8803 23.6801V92.7201C84.8803 93.3401 84.1803 93.7001 83.6703 93.3401L76.7304 88.3601C76.4704 88.1701 76.1203 88.1701 75.8503 88.3601L67.7604 93.9201C67.5004 94.1001 67.1604 94.1001 66.9004 93.9201L58.6203 88.3401C58.3603 88.1601 58.0203 88.1701 57.7603 88.3401L49.6304 93.9201C49.3804 94.0901 49.0504 94.1001 48.7904 93.9401L40.4804 88.6801C40.2304 88.5201 39.9104 88.5201 39.6604 88.6801L32.2904 93.4401C31.7804 93.7701 31.1104 93.4001 31.1104 92.8001L31.1204 92.8301Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.1298 48.8401H46.0498C44.8098 48.8401 43.7998 47.8301 43.7998 46.5901C43.7998 45.3501 44.8098 44.3401 46.0498 44.3401H70.1298C71.3698 44.3401 72.3798 45.3501 72.3798 46.5901C72.3798 47.8301 71.3698 48.8401 70.1298 48.8401Z",
			fill: "#001A43"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.1298 60.8201H46.0498C44.8098 60.8201 43.7998 59.8101 43.7998 58.5701C43.7998 57.3301 44.8098 56.3201 46.0498 56.3201H70.1298C71.3698 56.3201 72.3798 57.3301 72.3798 58.5701C72.3798 59.8101 71.3698 60.8201 70.1298 60.8201Z",
			fill: "#001A43"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.1298 72.79H46.0498C44.8098 72.79 43.7998 71.78 43.7998 70.54C43.7998 69.3 44.8098 68.29 46.0498 68.29H70.1298C71.3698 68.29 72.3798 69.3 72.3798 70.54C72.3798 71.78 71.3698 72.79 70.1298 72.79Z",
			fill: "#001A43"
		})
	]
});
export default SvgReceiptsEnrichedLight;
